import { QuantityUnit } from '@models/DomainModels/Master/quantity-unit';
import { ColDef } from 'ag-grid-enterprise';

interface GridColumnParams {
  t: (key: string) => string;
}

export const gridColumnDefinitions = ({ t }: GridColumnParams): ColDef<QuantityUnit>[] => {
  const columns: ColDef<QuantityUnit>[] = [
    {
      field: 'number',
      width: 120,
      filter: 'agNumberColumnFilter',
      headerName: t('headers.number')
    },
    {
      field: 'name',
      flex: 1,
      filter: 'agSetColumnFilter',
      filterParams: { caseSensitive: false, applyMiniFilterWhileTyping: true },
      headerName: t('headers.name')
    },
    {
      field: 'abbreviation',
      flex: 1,
      filter: 'agSetColumnFilter',
      filterParams: { caseSensitive: false, applyMiniFilterWhileTyping: true },
      headerName: t('headers.abbreviation')
    }
  ];

  return columns;
};
